var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPhishing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2929",
    "data-name": "Rectangle 2929",
    width: 24,
    height: 24,
    transform: "translate(-21624.75 -1851.958)",
    fill: "#003fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_phishing",
    transform: "translate(21624.75 1851.958)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hook-svgrepo-com",
    transform: "translate(-21620.305 -1851.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8699",
    "data-name": "Group 8699"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14355",
    "data-name": "Path 14355",
    d: "M100.385,15.82,98.37,16.887a3.555,3.555,0,1,0,7.11,0V4.651a2.666,2.666,0,1,1,3.555,0V16.886a7.11,7.11,0,1,1-14.22,0V10.606Zm6.873-12.265a.889.889,0,1,0-.889-.889A.89.89,0,0,0,107.258,3.555Z",
    transform: "translate(-94.815)",
    fill: "#003fb9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhishing);
export default __webpack_public_path__ + "static/media/ic_phishing.2ab059799f3ba0763d37847651bcb23e.svg";
export { ForwardRef as ReactComponent };